import { FormBuilderPanel } from './FormBuilder';

/**
 * FormsLibrary — /forms
 *
 * One surface: the PDF Form Builder. Upload a fillable PDF (an AcroForm), map each
 * of its fields to a system data path, then generate a filled, flattened copy for a
 * business and deliver it to that business's portal. The forms this serves are the
 * ones the Continuum of Care actually pushes paper on — capability statements, W-9s,
 * programme applications, partner referral forms.
 *
 * Wired to the real backend (src/routes/form-builder.js); the endpoint list lives on
 * FormBuilderPanel in ./FormBuilder. Staff-gated by the backend (requireStaff on
 * /api/form-builder); the business/partner portals never route here.
 *
 * There is exactly one tab because there is exactly one working surface: no route
 * serves /api/form-templates/*, and `form_templates` carries only Form Builder rows
 * (entity_type='pdf_form'). Do not add a region filter or a second entity picker
 * here. The {{token}} text-merge engine lives in src/services/form-templates.js and
 * is domain-neutral — that, not this page, is where a generated growth-plan or
 * referral-letter document would start.
 */
export function FormsLibrary() {
  return (
    <>
      <header style={{ marginBottom: 'var(--sp-5)' }}>
        <h1 style={{
          margin: 0, fontSize: 'var(--fs-3xl)', fontWeight: 'var(--fw-semibold)',
          letterSpacing: 'var(--ls-tight)', color: 'var(--color-ink)',
        }}>Forms</h1>
        <p style={{ margin: 'var(--sp-1) 0 0', color: 'var(--color-ink-3)', fontSize: 'var(--fs-md)' }}>
          Upload a fillable PDF, map its fields to business data, then generate and
          deliver a filled copy for any business — capability statements, W-9s,
          programme applications.
        </p>
      </header>

      <FormBuilderPanel />
    </>
  );
}
